import { Directive, HostListener, Input } from '@angular/core';
import { GoogleAnalyticsService } from '../../core/providers/google-analytics.service';

/**
 * Gombnyomás mérése a Google Analyticsben. (MIRA-789)
 *
 * Használat: <button gaClick="event_create"> ... </button>
 * Kiegészítő paraméterekkel: <button gaClick="event_create" [gaClickParams]="{ source: 'lista' }">
 *
 * A GA-ban egyetlen button_click esemény keletkezik, a gomb azonosítója a button_id paraméterben
 * van - így nem fogy el a GA4 500 eseménynévre szóló korlátja.
 */
@Directive({
    selector: '[gaClick]',
    standalone: false
})
export class GaClickDirective {
  /** A gomb azonosítója a statisztikában (rövid, angol, stabil - nem a felirata) */
  @Input() gaClick!: string;

  /** Opcionális, további esemény paraméterek */
  @Input() gaClickParams?: { [key: string]: any };

  constructor(private analytics: GoogleAnalyticsService) {}

  @HostListener('click')
  onClick() {
    if (!this.gaClick) {
      return;
    }

    this.analytics.trackEvent('button_click', {
      button_id: this.gaClick,
      ...this.gaClickParams
    });
  }
}
